export const salonInfo = {
  name: "SEREN MEN\'S SPA",
  tagline: "静寂の中に、本来の自分を取り戻す",
  description:
    "2018年の創業以来、男性のための専門的なボディケアとスキンケアを提供してまいりました。熟練のセラピストが、お客様一人ひとりの状態に合わせた施術をご提案いたします。",
  phone: "03-1234-5678",
  address: "東京都渋谷区神南1-2-3 セレンビル3F",
  hours: [
    { day: "月〜金", time: "11:00 〜 22:00" },
    { day: "土・日・祝", time: "10:00 〜 21:00" },
  ],
  closedDay: "不定休（公式SNSにてお知らせ）",
  seats: 6,
  instagram: "https://www.instagram.com/",
  line: "https://line.me/",
  mapEmbedUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.747985!2d139.6980!3d35.6612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188ca6d0000001%3A0x0!2z5riL5Lqs6YO95riL5Lqs5Yy65YmN5Yy6!5e0!3m2!1sja!2sjp!4v1234567890",
};

export const menuItems = [
  {
    id: 1,
    name: "ディープリラクゼーション",
    description:
      "全身の筋肉の緊張をほぐし、深いリラクゼーションへと導く90分のフルボディトリートメント。肩・腰・脚を重点的にケアします。",
    price: "¥12,000",
    duration: "90分",
    image:
      "https://readdy.ai/api/search-image?query=luxury%20mens%20spa%20massage%20treatment%20room%20with%20warm%20lighting%2C%20clean%20white%20linen%20on%20massage%20table%2C%20minimalist%20japanese%20interior%2C%20soft%20ambient%20light%2C%20serene%20atmosphere%2C%20professional%20wellness%20center%2C%20neutral%20tones%20beige%20and%20white%20background&width=800&height=500&seq=menu1&orientation=landscape",
  },
  {
    id: 2,
    name: "スカルプ＆フェイシャルケア",
    description:
      "頭皮の血行を促進するスカルプマッサージと、肌の状態を整えるフェイシャルケアを組み合わせた60分のコース。",
    price: "¥8,500",
    duration: "60分",
    image:
      "https://readdy.ai/api/search-image?query=mens%20facial%20skincare%20treatment%20in%20luxury%20spa%2C%20clean%20white%20towels%2C%20professional%20skincare%20products%20on%20marble%20surface%2C%20soft%20natural%20light%2C%20minimalist%20japanese%20aesthetic%2C%20calm%20serene%20environment%2C%20neutral%20beige%20background&width=800&height=500&seq=menu2&orientation=landscape",
  },
  {
    id: 3,
    name: "アロマオイルトリートメント",
    description:
      "厳選した天然アロマオイルを使用した全身トリートメント。香りと施術の相乗効果で、心身のバランスを整えます。",
    price: "¥14,000",
    duration: "90分",
    image:
      "https://readdy.ai/api/search-image?query=aromatherapy%20essential%20oils%20in%20small%20glass%20bottles%20on%20wooden%20tray%2C%20spa%20setting%2C%20warm%20candlelight%2C%20minimalist%20japanese%20interior%2C%20natural%20materials%2C%20soft%20beige%20and%20cream%20tones%2C%20luxury%20wellness%20atmosphere&width=800&height=500&seq=menu3&orientation=landscape",
  },
  {
    id: 4,
    name: "ストレッチ＆ボディワーク",
    description:
      "長時間のデスクワークや運動不足による体の硬さに対応。関節の可動域を広げ、姿勢改善をサポートする60分のコース。",
    price: "¥9,000",
    duration: "60分",
    image:
      "https://readdy.ai/api/search-image?query=professional%20stretching%20therapy%20session%20in%20clean%20wellness%20studio%2C%20minimalist%20interior%20with%20wooden%20floor%2C%20soft%20natural%20light%20from%20window%2C%20calm%20atmosphere%2C%20neutral%20white%20and%20beige%20tones%2C%20japanese%20spa%20aesthetic&width=800&height=500&seq=menu4&orientation=landscape",
  },
  {
    id: 5,
    name: "プレミアムリカバリー",
    description:
      "疲労回復に特化した120分のスペシャルコース。全身トリートメント・フェイシャル・スカルプケアをすべて含む、総合的なリカバリープログラム。",
    price: "¥18,000",
    duration: "120分",
    image:
      "https://readdy.ai/api/search-image?query=premium%20luxury%20spa%20treatment%20room%20with%20elegant%20decor%2C%20warm%20ambient%20lighting%2C%20fresh%20white%20towels%20and%20orchid%20flowers%2C%20japanese%20minimalist%20design%2C%20serene%20and%20sophisticated%20atmosphere%2C%20cream%20and%20warm%20beige%20color%20palette&width=800&height=500&seq=menu5&orientation=landscape",
  },
];

export const processSteps = [
  {
    step: "01",
    title: "ご予約",
    description: "お電話またはLINEにてご予約ください。初回の方はカウンセリング時間を含めてご案内いたします。",
  },
  {
    step: "02",
    title: "カウンセリング",
    description: "ご来店後、担当セラピストがお体の状態やご要望をヒアリングし、最適なコースをご提案いたします。",
  },
  {
    step: "03",
    title: "施術",
    description: "プライベートな個室にて、お客様のペースに合わせた施術を行います。途中でのご要望もお気軽にお申し付けください。",
  },
  {
    step: "04",
    title: "アフターケア",
    description: "施術後はリラクゼーションスペースにてゆっくりとお休みいただけます。次回のケアについてもご相談いただけます。",
  },
];

export const navLinks = [
  { label: "メニュー", href: "#services" },
  { label: "施術の流れ", href: "#process" },
  { label: "店舗情報", href: "#info" },
  { label: "アクセス", href: "#access" },
  { label: "ご予約", href: "#cta" },
];
